export default __webpack_public_path__ + "static/media/TF_08.233decde.png";